import React, {useEffect, useMemo, useState} from 'react';
import axios from "axios";
import BonusPointsItem from "./BonusPointsItem";

function BonusPointsList() {
    const [listBonusPoints, setListBonusPoints] = useState<any[]>([]);
    const [result, setResult] = useState('');
    const [loads, setLoads] = useState(true);

    // UI state: filter and sorting
    const [typeFilter, setTypeFilter] = useState<'ALL' | 'IN' | 'OUT'>('ALL');
    const [sortBy, setSortBy] = useState<'date' | 'amount'>('date');
    const [sortDir, setSortDir] = useState<'asc' | 'desc'>('desc');

    function getListBonusPoints() {
        axios.post(
            '/bitrix/services/main/ajax.php?action=enterego:bonuspoints.controller.bonus.getBonusList',
            {},
            {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Bitrix-Csrf-Token': (window as any).BX?.bitrix_sessid?.() || ''
                }
            }
        ).then(res => {
            if (res.data && res.data?.error === undefined) {
                setListBonusPoints(res.data.bonusList || []);
                setLoads(false);
            } else if (res.data?.error) {
                setResult(res.data.error);
                setLoads(false);
            } else {
                setLoads(false);
                setResult('К сожалению, возникла ошибка');
            }
        }).catch(error => {
            setResult(error.message);
            setLoads(false);
        });
    }

    useEffect(() => {
        getListBonusPoints();
    }, []);

    const displayedList = useMemo(() => {
        let arr = Array.isArray(listBonusPoints) ? [...listBonusPoints] : [];
        // Filter by type
        if (typeFilter !== 'ALL') {
            const isIncome = typeFilter === 'IN';
            arr = arr.filter((it: any) => {
                // DEBIT === 'Y' means income, otherwise expense
                const debit = (it?.DEBIT ?? '').toString();
                return isIncome ? debit === 'Y' : debit !== 'Y';
            });
        }
        // Sort
        arr.sort((a: any, b: any) => {
            let cmp = 0;
            if (sortBy === 'amount') {
                const av = parseFloat((a?.AMOUNT ?? 0).toString().replace(',', '.')) || 0;
                const bv = parseFloat((b?.AMOUNT ?? 0).toString().replace(',', '.')) || 0;
                cmp = av - bv;
            } else {
                // sort by date
                const ad = new Date(a?.TRANSACT_DATE ?? '').getTime() || 0;
                const bd = new Date(b?.TRANSACT_DATE ?? '').getTime() || 0;
                cmp = ad - bd;
            }
            return sortDir === 'asc' ? cmp : -cmp;
        });
        return arr;
    }, [listBonusPoints, typeFilter, sortBy, sortDir]);

    return (
        <div className="md:px-0 px-5">
            <div className="mt-5 dark:text-hover-red text-hover-red">{result}</div>

            <div>
                <p className="text-xl dark:text-textDarkLightGray text-textLight dark:font-normal
                                      flex flex-row justify-between font-semibold mb-4">
                    История начисления/списания бонусных баллов
                </p>

                {/* Controls: Filter and Sorting */}
                <div className="flex flex-col md:flex-row md:items-center flex-wrap lg:space-x-4 space-y-3 lg:space-y-0 mb-5">
                    <div className="flex items-center space-x-2">
                        <span className="text-sm dark:text-textDarkLightGray text-textLight">Фильтр:</span>
                        <select
                            className="bg-transparent border dark:border-darkBox/50 border-textDark/60 rounded-lg pl-2 pr-7 py-1 text-sm dark:text-textDarkLightGray text-textLight"
                            value={typeFilter}
                            onChange={(e) => setTypeFilter(e.target.value as any)}
                        >
                            <option value="ALL">Все</option>
                            <option value="IN">Приход</option>
                            <option value="OUT">Расход</option>
                        </select>
                    </div>
                    <div className="flex items-center space-x-2">
                        <span className="text-sm dark:text-textDarkLightGray text-textLight">Сортировка:</span>
                        <select
                            className="bg-transparent border dark:border-darkBox/50 border-textDark/60 rounded-lg pl-2 pr-7 py-1 text-sm dark:text-textDarkLightGray text-textLight"
                            value={sortBy}
                            onChange={(e) => setSortBy(e.target.value as any)}
                        >
                            <option value="date">По дате</option>
                            <option value="amount">По сумме</option>
                        </select>
                        <select
                            className="bg-transparent border dark:border-darkBox/50 border-textDark/60 rounded-lg pl-2 pr-7 py-1 text-sm dark:text-textDarkLightGray text-textLight"
                            value={sortDir}
                            onChange={(e) => setSortDir(e.target.value as any)}
                        >
                            <option value="desc">По убыванию</option>
                            <option value="asc">По возрастанию</option>
                        </select>
                    </div>
                </div>

                {
                    loads ?
                        <div className="flex flex-row flex-wrap">
                            {[...Array(5)].map((_, index) => (
                                <div
                                    key={index}
                                    className="h-24 dark:bg-darkBox bg-textDark rounded-xl w-full mb-2 animate-pulse"
                                >
                                </div>
                            ))}
                        </div>
                        :
                        displayedList.length > 0 ?
                            <div className="flex flex-row flex-wrap">
                                {displayedList.map((bonusPoints, keys) =>
                                    <BonusPointsItem key={keys} bonusPoints={bonusPoints} />)}
                            </div>
                            : <div className="dark:bg-darkBox bg-textDark rounded-xl">
                                <p className="text-base dark:text-textDarkLightGray text-textLight dark:font-normal
                                      flex flex-row justify-between font-semibold px-2 py-4">
                                    Нет записей о начислении/списании бонусных баллов
                                </p>
                            </div>
                }
            </div>
        </div>
    );
}

export default BonusPointsList;